import React from 'react'
import CTAButton from '../Buttons/CTAButton/CTAButton'

const RextroBanner = () => {
  return (
    <section className="bg-Color-White px-4 sm:px-8 lg:px-numbers-100 py-6 sm:py-8 lg:py-numbers-48 mt-8 sm:mt-12 lg:mt-numbers-64">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-[20px] sm:gap-[30px] lg:gap-[40px]">
        
        {/* Text Content Section - Left Side */}
        <div className="border-l-2 border-l-Color-Brand py-4 sm:py-8 lg:py-numbers-16 pl-4 sm:pl-6 lg:pl-numbers-32">
          <h1 className="text-xl sm:text-2xl lg:text-h2-desktop mb-2 sm:mb-3 lg:mb-4">rextro.lk:</h1>
          <span className="text-Color-Brand text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-semibold font-['Montserrat'] underline">
            Official Website Unveiled!
          </span>
          
          <p className="leading-tight mt-4 sm:mt-6 lg:mt-[40px] font-medium text-sm sm:text-base lg:text-body-desktop">
            The future is here! We are thrilled to announce the launch of the official Rextro 2025 website.
          </p>

          {/* Event Dates Highlight */}
          <div className="mt-4 sm:mt-6 inline-block bg-Color-Brand/10 border-2 border-Color-Brand/30 rounded-lg px-4 sm:px-6 py-2 sm:py-3">
            <p className="text-Color-Brand text-base sm:text-lg lg:text-xl font-bold font-['Montserrat']">
              Mark your calendars: December 13th, 14th, and 15th!
            </p>
          </div>

          <p className="leading-tight mt-4 sm:mt-6 font-medium text-sm sm:text-base lg:text-body-desktop">
            Get the latest details on all events, registrations, schedules, and more directly on the new platform.
          </p>

          <p className="leading-tight mt-4 sm:mt-6 font-semibold text-base sm:text-lg lg:text-xl">
            Don't miss out! Visit the new home of Rextro 2025 now:
          </p>

          <div className="mt-4 sm:mt-6 lg:mt-[40px]">
            <CTAButton text="GO TO REXTRO.LK" url="https://rextro.lk" isRainbow={true} size="lg" />
          </div>
        </div>

        {/* Logo Section - Right Side */}
        <div className="flex items-center justify-center">
          <div className="relative">
            <img 
              src="/assets/logo 2.svg" 
              alt="Rextro 2025 Logo" 
              className="relative z-10 w-64 h-64 sm:w-80 sm:h-80 lg:w-96 lg:h-96 xl:w-[450px] xl:h-[450px] object-contain drop-shadow-2xl"
            />
          </div>
        </div>

      </div>
    </section>
  )
}

export default RextroBanner
